export type SearchFilterValue = string | number;

export type SearchFilterSelectionValue<TValue extends SearchFilterValue = SearchFilterValue> =
    TValue | readonly TValue[] | null | undefined;

export function isSearchFilterSelectionArray<TValue extends SearchFilterValue>(
    value: SearchFilterSelectionValue<TValue>,
): value is readonly TValue[] {
    return Array.isArray(value);
}

export interface SearchFilterOption<TValue extends SearchFilterValue = SearchFilterValue> {
    value: TValue;
    label: string;
    metadata?: unknown;
}

export type SearchFilterSelection<TValue extends SearchFilterValue = SearchFilterValue> =
    Record<string, SearchFilterSelectionValue<TValue>>;

export interface SearchFilterImpact<TValue extends SearchFilterValue = SearchFilterValue> {
    enabled?: boolean;
    allowedOptionValues?: readonly TValue[];
    resetSelection?: boolean;
}

export interface SearchFilterImpactContext<TValue extends SearchFilterValue = SearchFilterValue> {
    selection: Readonly<SearchFilterSelection<TValue>>;
    currentFilter: SearchFilterDefinition<TValue>;
    previousFilter?: SearchFilterDefinition<TValue>;
}

export interface SearchFilterDefinition<TValue extends SearchFilterValue = SearchFilterValue> {
    key: string;
    queryParam: string;
    labelKey: string;
    options: readonly SearchFilterOption<TValue>[];
    multiple?: boolean;
    enabled?: boolean;
    loading?: boolean;
    impact?: (context: SearchFilterImpactContext<TValue>) => SearchFilterImpact<TValue>;
}

export interface SearchFilterViewModel<TValue extends SearchFilterValue = SearchFilterValue> {
    definition: SearchFilterDefinition<TValue>;
    options: readonly SearchFilterOption<TValue>[];
    selectedValue: SearchFilterSelectionValue<TValue>;
    enabled: boolean;
}
